import { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { useAuth, podeLancar } from "./lib/AuthContext";
import { supabase } from "./lib/supabase";
import { ProtectedRoute } from "./lib/ProtectedRoute";
import { Login } from "./pages/Login";
import { ResetPassword } from "./pages/ResetPassword";
import { Dashboard } from "./pages/Dashboard";
import { LancarDados } from "./pages/LancarDados";
import { Imprimir } from "./pages/Imprimir";

function RequireLancador({ children }: { children: React.ReactNode }) {
  const { profile } = useAuth();
  if (!podeLancar(profile)) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export default function App() {
  const navigate = useNavigate();

  useEffect(() => {
    const { data: sub } = supabase.auth.onAuthStateChange((event) => {
      if (event === "PASSWORD_RECOVERY") navigate("/reset-password", { replace: true });
    });
    return () => sub.subscription.unsubscribe();
  }, [navigate]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/lancar"
        element={
          <ProtectedRoute>
            <RequireLancador>
              <LancarDados />
            </RequireLancador>
          </ProtectedRoute>
        }
      />
      <Route
        path="/imprimir"
        element={
          <ProtectedRoute>
            <Imprimir />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
